import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import { userName, nameFirme, kindName, rCount } from "@/helpers/reference";

const state = {
  bankPayFilter: {
    period: {
      enabled: false,
      dateBegin: "",
      dateEnd: ""
    },
    sum: {
      enabled: false,
      sumBegin: "",
      sumEnd: ""
    },
    statement: {
      enabled: false,
      status: ""
    }
  },
  bankStat: {
    data: []
  },
  payDoc: {
    data: []
  },
  payDocModal: {
    data: [],
    delete: []
  },
  statusModifyBankStat: null,
  statusUploadFile: null
};

const mutations = {
  setBankPayFilter: (state, payload) => (state.bankPayFilter = payload),
  setBankStat: (state, payload) => (state.bankStat = payload),
  clearBankStat: state => (state.bankStat = { data: [] }),
  setPayDoc: (state, payload) => (state.payDoc = payload),
  clearPayDoc: state => (state.payDoc = { data: [] }),
  setPayDocModal: (state, payload) => (state.payDocModal = payload),
  clearPayDocModal: state => (state.payDocModal = { data: [], delete: [] }),
  editPayDocModal: (state, payload) => {
    const index = state.payDocModal.data.findIndex(
      item => item.paysheetid === payload.paysheetid
    );
    if (index !== -1) {
      let mutatationPayDocModal = [...state.payDocModal.data];
      mutatationPayDocModal[index] = payload;
      state.payDocModal.data = [...mutatationPayDocModal];
    }
  },
  deletePayDocModal: (state, payload) => {
    state.payDocModal.data = [
      ...state.payDocModal.data.filter(
        item => item.paysheetid !== payload.paysheetid
      )
    ];
    if (payload.addstatus !== "1") {
      state.payDocModal.delete.push(payload.paysheetid);
    }
  },
  addPayDocModal: (state, payload) => state.payDocModal.data.push(payload),
  importPayDocModal: (state, payload) => (state.payDocModal.data = payload),
  setStatusModifyBankStat: (state, payload) =>
    (state.statusModifyBankStat = payload),
  setStatusUploadFile: (state, payload) => (state.statusUploadFile = payload)
};

const actions = {
  async getBankStat({ commit, state, rootState }) {
    try {
      commit("setLoading", true);

      const filter = state.bankPayFilter;
      let params = {
        script: "web.wbtstatement",
        funcname: "wbRunSelect",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`
      };

      if (filter.sum.enabled) {
        params["sumBegin"] = filter.sum.sumBegin;
        params["sumEnd"] = filter.sum.sumEnd;
      }
      if (filter.statement.enabled) {
        params["status"] = filter.statement.status;
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setBankStat", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async deleteBankStat({ commit, rootState }, { statementid }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbtstatementstorn",
            funcname: "wbRunStorn",
            statementid: `${statementid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusModifyBankStat", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPayDoc({ commit, rootState }, { statementid }) {
    try {
      commit("setLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbtpaysheet",
            funcname: "wbRunSelect",
            statementid: `${statementid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPayDoc", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async uploadFile({ commit, rootState }, { account, encoding, file }) {
    try {
      commit("setFullPageLoading", true);

      const command = {
        cmd: "luaFunc",
        params: {
          script: "web.wbtpaysheetconv",
          funcname: "wbRunImport",
          account: `${account}`,
          codepage: `${encoding}`
        }
      };

      const formData = new FormData();
      formData.append("command", JSON.stringify(command));
      formData.append("upload1", file.raw);

      const response = await Vue.axios.post(rootState.auth.base.url, formData, {
        headers: {
          Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
        }
      });

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusUploadFile", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async bankStatPayDocEdit(
    { commit, rootState },
    {
      datebank,
      quantity,
      accountid,
      statementid,
      status,
      datebeginfact,
      summa,
      isimport
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const payDoc = [];
      state.payDocModal.data.forEach(item => {
        const {
          addstatus,
          editstatus,
          codefirme,
          datepay,
          kindpay,
          paysheetid,
          mess,
          okpo,
          datebeginfact,
          statementid,
          summa,
          paynumber,
          astatus
        } = item;
        if (addstatus === "1" || editstatus === "1") {
          let newItem = {
            codefirme,
            datepay,
            kindpay,
            paysheetid: addstatus === "1" ? "" : paysheetid,
            mess,
            okpo,
            datebeginfact,
            statementid,
            summa,
            paynumber,
            status: astatus
          };
          payDoc.push(newItem);
        }
      });

      let params = {
        script: "web.wbplatedit",
        funcname: "wbRunEdit",
        paysheetrecordstorn: {
          data: [...state.payDocModal.delete]
        },
        tstatement: {
          data: [
            {
              datebank: `${datebank}`,
              quantity: `${quantity}`,
              accountid: `${accountid}`,
              statementid: `${statementid}`,
              status: `${status}`,
              datebeginfact: `${datebeginfact}`,
              summa: `${summa}`,
              isimport: `${isimport}`
            }
          ]
        },
        tpaysheet: {
          data: payDoc
        }
      };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusModifyBankStat", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  bankPayFilter: state => state.bankPayFilter,
  bankStat: (state, rootState) => {
    let items = [];
    state.bankStat.data.forEach(item => {
      item["nameaccount"] = rCount(
        rootState.params.account.data,
        item.accountid
      );
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      items.push(item);
    });
    return items;
  },
  payDoc: (state, rootState) => {
    let items = [];
    state.payDoc.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["addstatus"] = "";
      item["editstatus"] = "";
      items.push(item);
    });
    return items;
  },
  payDocModal: (state, rootState) => {
    let items = [];
    state.payDocModal.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      items.push(item);
    });
    return items;
  },
  statusModifyBankStat: state => state.statusModifyBankStat,
  statusUploadFile: state => state.statusUploadFile
};

export default { state, mutations, actions, getters };
